import React from "react";

import Badge from "antd/es/badge";
import { FormattedMessage } from "react-intl";

import styles from "./MappingInformation.module.scss";

interface Props {
  mapped: boolean;
}

const MappingInformation: React.FC<Props> = ({ mapped }) => (
  <div className={styles.container}>
    <Badge status={mapped ? "success" : "default"} />
    <p className={styles.text}>
      <FormattedMessage
        id="integrations.matchInformation"
        defaultMessage="{mapped, select, true {Matched} other {Not matched}}"
        description="Text of Mapped status"
        values={{ mapped }}
      />
    </p>
  </div>
);

export default MappingInformation;
